// Static church branch data
export const BRANCHES = [
  {
    id: "nelspruit",
    name: "Nelspruit (Mbombela)",
    role: "Headquarters",
    city: "Mpumalanga · South Africa",
    address: "GWMJ+8M, Mbombela",
    times: [
      { day: "Sunday", label: "Intercession (Prayer)", time: "08:00" },
      { day: "Sunday", label: "Main Service", time: "08:30 – 10:30" },
      { day: "Wednesday", label: "Homecell", time: "18:30" },
      { day: "Friday", label: "Youth Gathering", time: "17:00" },
      { day: "Friday", label: "Prayer Night", time: "19:00" },
    ],
    phone: "082 447 1527",
  },
  {
    id: "kanyamazane",
    name: "Kanyamazane",
    role: "Branch",
    city: "Mpumalanga · South Africa",
    address: "10 Wasp St, Kanyamazane-A, Kanyamazane, 1214",
    times: [
      { day: "Sunday", label: "Intercession (Prayer)", time: "08:00" },
      { day: "Sunday", label: "Main Service", time: "08:30 – 10:30" },
    ],
    phone: "082 447 1527",
  },
  {
    id: "msogwaba",
    name: "Msogwaba",
    role: "Branch",
    city: "Mpumalanga · South Africa",
    address: "Msogwaba, Mpumalanga",
    times: [
      { day: "Sunday", label: "Intercession (Prayer)", time: "08:00" },
      { day: "Sunday", label: "Main Service", time: "08:30 – 10:30" },
    ],
    phone: "082 447 1527",
  },
  {
    id: "kabokweni",
    name: "Kabokweni",
    role: "Branch",
    city: "Mpumalanga · South Africa",
    address: "M486+H7, Phathwa, Kabokweni",
    times: [
      { day: "Sunday", label: "Intercession (Prayer)", time: "08:00" },
      { day: "Sunday", label: "Main Service", time: "08:30 – 10:30" },
    ],
    phone: "082 447 1527",
  },
  {
    id: "emalahleni",
    name: "Emalahleni",
    role: "Branch",
    city: "Mpumalanga · South Africa",
    address: "Emalahleni, Mpumalanga",
    times: [
      { day: "Sunday", label: "Intercession (Prayer)", time: "08:00" },
      { day: "Sunday", label: "Main Service", time: "08:30 – 10:30" },
    ],
    phone: "082 447 1527",
  },
  {
    id: "witbank",
    name: "Witbank",
    role: "Branch",
    city: "Mpumalanga · South Africa",
    address: "3526 Tc Magwaza St, eMalahleni, 1039",
    times: [
      { day: "Sunday", label: "Intercession (Prayer)", time: "08:00" },
      { day: "Sunday", label: "Main Service", time: "08:30 – 10:30" },
    ],
    phone: "068 225 0132",
  },
];

export const CONTACT = {
  email: "elshaddainst@gmail.com",
  phone: "082 447 1527",
  city: "GWMJ+8M, Mbombela",
};

export const BANK_DETAILS = {
  account_name: "Elshaddai National",
  bank: "Standard Bank",
  account_number: "032 939 507",
  branch_code: "051 001",
};

export const YOUTUBE_CHANNEL = "https://www.youtube.com/@ETIMBOMBELA";

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_church-connect-165/artifacts/bywt6ogz_ETI%20Logo.jpg";
